export default "__VITE_PUBLIC_ASSET__bd9f4c1f__"